// extracted by mini-css-extract-plugin
export default {"list":"CartList_list__SH7dy","item":"CartList_item__l+k1H"};